import { TextField } from '@/components/ui/TextField';

import { TextFieldProps } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { FC } from 'react';
import styled from 'styled-components';

interface SearchBarButtonProps {
  label: string;
  disabled: boolean;
  hideButton?: boolean;
  hideCheckbox?: boolean;
  isChecked?: boolean;
  onSearch: (event: React.KeyboardEvent | React.MouseEvent) => void;
  onCheck: () => void;
}

// TODO: create an input component
const useStyles = makeStyles(() =>
  createStyles({
    input: {
      height: 56,
    },
  })
);

const StyledSearchContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: flex-start;
  justify-content: center;
  gap: 8px;
  padding: 34px 0 0;
`;

const StyledSearchBar = styled(TextField)`
  width: 305px;

  fieldset {
    border-radius: 4px;
  }
`;
//#endregion

type SearchBarProps = Omit<TextFieldProps, 'variant'> &
  SearchBarButtonProps & {
    loading: boolean;
  } & React.ComponentPropsWithRef<'div'>;

export const SearchBarLight: FC<SearchBarProps> = ({
  placeholder,
  value,
  onChange,
  error,
  helperText,
  label,
  disabled,
  hideButton,
  onSearch,
  loading,
  hideCheckbox = false,
  isChecked,
  onCheck,
  ...props
}) => {
  const classes = useStyles();

  return (
    <StyledSearchContainer {...props}>
      <StyledSearchBar
        placeholder={placeholder}
        label={placeholder}
        value={value}
        onChange={onChange}
        onKeyDown={onSearch}
        disabled={disabled}
        variant="outlined"
        InputProps={{
          className: classes.input,
          startAdornment: props.InputProps?.startAdornment,
          endAdornment: !hideCheckbox && (
            <Checkbox checked={isChecked} onClick={onCheck} color="primary" />
          ),
        }}
        inputProps={{
          maxLength: 13,
          minLength: 5,
          ...props.inputProps,
        }}
        required
        error={error}
        helperText={helperText}
      />
    </StyledSearchContainer>
  );
};

export default SearchBarLight;
